// extracted by mini-css-extract-plugin
export default {"plansPage":"Plans_plansPage__GJO5K","plans":"Plans_plans__VX240","pageContent":"Plans_pageContent__zF2ab"};